import { render } from "./guaranteedIncomeChecker.vue?vue&type=template&id=28d8962c&ts=true"
import script from "./guaranteedIncomeChecker.vue?vue&type=script&lang=ts"
export * from "./guaranteedIncomeChecker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__